import script from "./GenreSelectionOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenreSelectionOption.vue?vue&type=script&setup=true&lang=ts"

import "./GenreSelectionOption.vue?vue&type=style&index=0&id=608ecbe5&lang=scss"

const __exports__ = script;

export default __exports__